// SnapCanvas.tsx
import React from 'react';
import { useNode } from '@craftjs/core';
import styles from './styles/styles.module.css';

const SnapCanvas: React.FC<{
  children?: React.ReactNode;
  showGrid?: boolean;
}> = ({ children, showGrid = true }) => {
  const {
    connectors: { connect }, // ✅ no 'drop' here in your types
  } = useNode();

  return (
    <div
      ref={(ref: HTMLDivElement | null) => ref && connect(ref)} // ✅ connect only
      className={`${styles.snapCanvas} ${!showGrid ? styles.noGrid : ''}`}
    >
      {children}
    </div>
  );
};

(SnapCanvas as any).craft = {
  displayName: 'SnapCanvas',
  props: { showGrid: true },
  rules: { canMoveIn: () => true }, // optional; keep if you had it
};

export default SnapCanvas;
